import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Row } from 'antd';
import TooltipHelp from 'components/Tooltip/tooltipHelp';
import InputSelect from 'components/InputSelect';
import Titulo from 'components/Titulo';
import { FORMULARIOS } from 'utils/consts';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import {
  fetchAlterarOptionsInputSelectServicoPersonalizado,
  fetchGetTodasSolicitacao,
} from 'store/fetchActions/fetchInputForm';
import { montarServicosUrl } from './FormServicoDuvida';
import { reloadVlibras } from 'utils/acessibilidade';

export default function Servico({
  control,
  onChange,
  errors,
  tipoFormulario,
  disabled,
  setDadosServico,
  verificarRepeticao,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const parametersQuery = new URLSearchParams(history?.location?.search);

  const servicoSelecionadoUrl = parametersQuery.get('servico');
  const listaServicoExibirUrl = parametersQuery.get('lista');

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const inputSelectOptionsServicos = useSelector(state => state.inputs.inputSelectOptionsServicos);

  const [todosServicos, setTodosServicos] = useState([]);
  const [tooltipServico, setTooltipServico] = useState('');

  React.useEffect(() => {
    if (unitaryTests) return;
    if (tipoFormulario === FORMULARIOS.SERVICOS.id) {
      dispatch(fetchGetTodasSolicitacao()).then(resposta => {
        setTodosServicos(resposta);
        const { listaExibir, itemSelecionado } = montarServicosUrl(
          resposta,
          listaServicoExibirUrl,
          servicoSelecionadoUrl
        );
        if (itemSelecionado) {
          onChange({ target: { name: 'servico', value: itemSelecionado?.id } });
          setDadosServico(itemSelecionado);
        }
        if (listaExibir) {
          dispatch(fetchAlterarOptionsInputSelectServicoPersonalizado(listaExibir));
        }
      });
    }
    // eslint-disable-next-line
  }, [dispatch, tipoFormulario, listaServicoExibirUrl, servicoSelecionadoUrl]);

  const handleChangeServico = id => {
    const solicitacaoFind = todosServicos.find(solicitacao => solicitacao.id === id);
    setDadosServico(solicitacaoFind);
    setTooltipServico(solicitacaoFind?.descricao);
    verificarRepeticao();
    reloadVlibras();
  };

  const carregarTodosServicos = () => {
    dispatch(fetchAlterarOptionsInputSelectServicoPersonalizado(todosServicos));
  };

  const onClear = () => {
    setTooltipServico('');
    setDadosServico({});
  };

  return (
    <>
      {tipoFormulario === FORMULARIOS.SERVICOS.id && (
        <>
          <Titulo textTitle={'Serviços'} />
          <Row align="middle">
            <div style={{ width: '40%' }}>
              <InputSelect
                label="* Serviços"
                name="servico"
                errors={errors}
                placeholder={'Selecionar um serviço'}
                control={control}
                options={montarDadosInputSelect(inputSelectOptionsServicos, 'id', 'nome')}
                disabled={disabled}
                onClear={onClear}
                viewChange={handleChangeServico}
                isShowLoadingMore={listaServicoExibirUrl !== null}
                onClickLoadMore={carregarTodosServicos}
              />
            </div>
            {tooltipServico && (
              <TooltipHelp text={tooltipServico} style={{ marginLeft: '10px', marginTop: '21px', fontSize: '1.3em' }} />
            )}
          </Row>
        </>
      )}
    </>
  );
}

Servico.propTypes = {
  control: PropTypes.object,
  onChange: PropTypes.func,
  errors: PropTypes.object,
  disabled: PropTypes.bool,
  getValues: PropTypes.func,
  setDocumentos: PropTypes.func,
};
